import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { isValidHighlights } from '../../entities/Highlights';
import { BaseClient } from '../BaseClient';
export class HighlightsClientBase extends BaseClient {
  constructor() {
    super(...arguments);
    _defineProperty(this, "getHighlightsImpl", void 0);
    _defineProperty(this, "getTaskSummaryImpl", void 0);
  }
  async getHighlights(interval) {
    try {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      const {
        highlights
      } = await this.request(this.getHighlightsImpl({
        interval: this.convertInterval(interval)
      }), ...args);
      return this.convertToEntity(highlights);
    } catch (error) {
      this.logError('getHighlights', 'Failed to get highlights', {
        interval
      }, error);
      throw error;
    }
  }
  async getTasksSummaryText(interval) {
    try {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      const {
        summaryText
      } = await this.request(this.getTaskSummaryImpl({
        interval: this.convertInterval(interval)
      }), ...args);
      if (!summaryText) {
        throw new Error('Empty summary');
      }
      return summaryText;
    } catch (error) {
      this.logError('getTasksSummaryText', 'Failed to get tasks summary text', {
        interval
      }, error);
      throw error;
    }
  }
  convertToEntity(highlights) {
    try {
      if (!highlights) {
        throw new Error('Invalid highlights', {
          cause: {
            highlights
          }
        });
      }
      const {
        clientsReachedOut,
        tasks,
        recurringSchedules
      } = highlights || {};
      const convertedHighlights = {
        clientsReachedOut,
        tasks,
        recurringSchedules
      };
      if (isValidHighlights(convertedHighlights)) {
        return convertedHighlights;
      }
      throw new Error('Invalid highlights data', {
        cause: {
          highlights
        }
      });
    } catch (error) {
      this.logError('convertToEntity', 'Failed to convert highlights', {
        highlights
      }, error);
      throw error;
    }
  }
  getServiceNameForLogs() {
    return 'HighlightsClient';
  }
  convertInterval(interval) {
    const {
      startTimestamp,
      endTimestamp
    } = interval;
    return {
      startDate: new Date(startTimestamp),
      endDate: new Date(endTimestamp)
    };
  }
}
//# sourceMappingURL=HighlightsClientBase.js.map